export type AccountDestination = {
  id: "activity" | "agents" | "integrations" | "machines" | "calendar";
  icon: "activity" | "bot" | "puzzle" | "cpu" | "calendar";
  labelKey: "you.activity" | "you.agents" | "you.integrations" | "you.machines" | "you.calendar";
};

export const ACCOUNT_DESTINATIONS: readonly AccountDestination[] = [
  { id: "activity", icon: "activity", labelKey: "you.activity" },
  { id: "calendar", icon: "calendar", labelKey: "you.calendar" },
  { id: "agents", icon: "bot", labelKey: "you.agents" },
  { id: "machines", icon: "cpu", labelKey: "you.machines" },
];

export const FORMER_DESTINATIONS: Record<string, AccountDestination["id"]> = {
  providers: "integrations",
  integrations: "integrations",
};

const BODY_IDS: readonly string[] = [
  ...ACCOUNT_DESTINATIONS.map((one) => one.id),
  ...Object.keys(FORMER_DESTINATIONS),
];

export function isAccountBody(section: string | undefined): boolean {
  return section !== undefined && BODY_IDS.includes(section);
}
